import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'Encrypted Connection',
      color: 'var(--color-accent)'
    },
    {
      icon: 'Lock',
      text: 'Secure Authentication',
      color: 'var(--color-primary)'
    },
    {
      icon: 'Eye',
      text: 'Privacy Protected',
      color: 'var(--color-secondary)'
    }
  ];

  return (
    <div className="mt-6 md:mt-8 lg:mt-10">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex items-center justify-center gap-2 p-3 md:p-4 bg-card/50 border border-primary/20 rounded-sm hover:border-primary/50 transition-all duration-base"
          >
            <Icon name={feature?.icon} size={16} color={feature?.color} />
            <span className="text-xs md:text-sm font-caption text-muted-foreground">
              {feature?.text}
            </span>
          </div>
        ))}
      </div>
      <div className="mt-4 md:mt-6 text-center">
        <p className="text-xs md:text-sm font-body text-muted-foreground">
          Your data is protected with military-grade encryption
        </p>
      </div>
    </div>
  );
};

export default SecurityBadges;